import { Alert, Icon, Modal, ModalBody, ModalHeader, Text, VFlow } from 'bold-ui'
import { ButtonLink } from 'components/route'
import { css } from 'emotion'
import { LotacaoContextModel } from 'hooks/atendimento-context/model-atendimentoContext'
import React from 'react'
import { Route, useHistory, useRouteMatch } from 'react-router-dom'
import { LotacaoFolhaRosto } from 'view/atendimentos/detail/folha-rosto/model'

import { EncaminhamentoExternoTable } from '../../encaminhamento-externo/list/EncaminhamentoExternoTable'

interface HistoricoEncaminhamentoModalProps {
  prontuarioId: ID
  atendimentoId: ID
  atendimentoProfissionalId?: ID
  lotacao: LotacaoFolhaRosto | LotacaoContextModel
  dataReferencia: Instant
}

const HISTORICO_ENCAMINHAMENTOS_PATH = '/historico-encaminhamentos'

export function HistoricoEncaminhamentoExterno(props: Readonly<HistoricoEncaminhamentoModalProps>) {
  const { prontuarioId, atendimentoId, atendimentoProfissionalId, lotacao, dataReferencia } = props

  const history = useHistory()
  const match = useRouteMatch()

  return (
    <>
      <VFlow vSpacing={0.5}>
        <Alert type='info'>
          O histórico dos encaminhamentos anteriores à unificação das abas ainda está disponível para acesso.
        </Alert>

        <ButtonLink to={`${match.url}${HISTORICO_ENCAMINHAMENTOS_PATH}`} kind='primary' size='small' skin='outline'>
          <Icon
            icon='zoomOutline'
            style={css`
              margin-right: 0.5rem;
            `}
          />
          Histórico anterior à unificação
        </ButtonLink>
      </VFlow>

      <Route path={`${match.url}${HISTORICO_ENCAMINHAMENTOS_PATH}`}>
        <Modal size='large' open={true} onClose={() => history.push(match.url)}>
          <ModalHeader title='Histórico anterior à unificação' />
          <ModalBody>
            <VFlow vSpacing={2}>
              <Text>
                Aqui você acessa os encaminhamentos feitos antes da unificação das abas e encaminhamentos gerados em
                atendimentos odontológicos, que continuam no formato anterior.
              </Text>

              <EncaminhamentoExternoTable
                prontuarioId={prontuarioId}
                atendimentoId={atendimentoId}
                atendimentoProfissionalId={atendimentoProfissionalId}
                lotacao={lotacao}
                dataReferencia={dataReferencia}
              />
            </VFlow>
          </ModalBody>
        </Modal>
      </Route>
    </>
  )
}
